import ace from 'ace-builds'

ace.define(
  'ace/snippets/sf_liquid',
  ['require', 'exports', 'module'],
  function (require, exports, _module) {
    exports.snippetText =
      '# Sf-Liquid\n\
snippet ABS\n\
\tABS(${1:value})\n\
\n\
\n\
snippet INT\n\
\tINT(${1:value})\n\
\n\
\n\
snippet IRR\n\
\tIRR(${1:value1};${2:value2};${3:value3})\n\
\n\
\n\
snippet MAX\n\
\tMAX(${1:value1};${2:value2};${3:value3})\n\
\n\
\n\
snippet MIN\n\
\tMIN(${1:value1};${2:value2};${3:value3})\n\
\n\
\n\
snippet RATE\n\
\tRATE(${1:nper};${2:pmt};${3:pv})\n\
\n\
\n\
snippet table\n\
\t{% stripnewlines %}\n\
\t| ${1:Header 1}\n\
\t| ${2:Header 2}\n\
\t{% newline %}\n\
\t|--------\n\
\t|--------\n\
\t{% newline %}\n\
\t| ${3:content}\n\
\t| ${4:content}\n\
\t{% newline %}\n\
\t| ${5:content}\n\
\t| ${6:content}\n\
\t{% endstripnewlines %}\n\
\n\
\n\
snippet |table\n\
\t{% stripnewlines %}\n\
\t| ${1:Header 1}\n\
\t| ${2:Header 2}\n\
\t{% newline %}\n\
\t|--------\n\
\t|--------\n\
\t{% newline %}\n\
\t| ${3:content}\n\
\t| ${4:content}\n\
\t{% newline %}\n\
\t| ${5:content}\n\
\t| ${6:content}\n\
\t{% endstripnewlines %}\n\
\n\
\n\
snippet addnewinputs\n\
\t{% addnewinputs %}${1:content}{% endaddnewinputs %}\n\
\n\
\n\
snippet add_new_row_button\n\
\t{% add_new_row_button target:${1:target} %}\n\
\n\
\n\
snippet assign\n\
\t{% assign ${1:variable} = ${2:content} %}\n\
\n\
\n\
snippet break\n\
\t{% break %}\n\
\n\
\n\
snippet capture\n\
\t{% capture ${1:variable} %}${2:content}{% endcapture %}\n\
\n\
\n\
snippet case\n\
\t{% case ${1:value} %}\n\
\t{% when ${2:condition} %}\n\
\t\t${3:content}\n\
\t{% when ${4:condition} %}\n\
\t\t${5:content}\n\
\t{% else %}\n\
\t\t${6:content}\n\
\t{% endcase %}\n\
\n\
\n\
snippet changeorientation\n\
\t{% changeorientation ${1:variable}.preferred_orientation %}\n\
\n\
\n\
snippet comment\n\
\t{% comment %}${1:your comments}{% endcomment %}\n\
\n\
\n\
snippet continue\n\
\t{% continue %}\n\
\n\
\n\
snippet currencyconfiguration\n\
\t{% currencyconfiguration ${1:negative_format} ${2:zero_format} ${3:precision} ${4:delimiter} ${5:separator} %}{% endcurrencyconfiguration %}\n\
\n\
\n\
snippet cycle\n\
\t{% cycle ${1:\'one\'}, ${2:\'two\'}, ${3:\'three\'} %}\n\
\n\
\n\
snippet decrement\n\
\t{% decrement ${1:variable} %}\n\
\n\
\n\
snippet for\n\
\t{% for ${1:item} in ${2:collection} %}${3:content}{% endfor %}\n\
\n\
\n\
snippet fori\n\
\t{% fori ${1:item} in ${2:collection} %}${3:content}{% endfori %}\n\
\n\
\n\
snippet fix_indent\n\
\t{% fix_indent %}\n\
\t<table>${1:content}</table>\n\
\t{% endfix_indent %}\n\
\n\
\n\
snippet hideunlessi\n\
\t{% hideunlessi ${1:condition} %}${2:content}{% endhideunlessi %}\n\
\n\
\n\
snippet if\n\
\t{% if ${1:condition} %}${2:content}{% endif %}\n\
\n\
\n\
snippet ifelse\n\
\t{% if ${1:condition} %}${2:content}{% else %}${3:content}{% endif %}\n\
\n\
\n\
snippet else\n\
\t{% else %}\n\
\n\
\n\
snippet elsif\n\
\t{% elsif ${1:condition} %}\n\
\n\
\n\
snippet ifi\n\
\t{% ifi ${1:condition} %}${2:content}{% endifi %}\n\
\n\
\n\
snippet increment\n\
\t{% increment ${1:variable} %}\n\
\n\
\n\
snippet input\n\
\t{% input ${1:prefix}.${2:suffix} %}\n\
\n\
\n\
snippet input_validation\n\
\t{% input_validation ${1:name} ${2:attributes}  %}\n\
\n\
\n\
snippet inputcomment\n\
\t{% inputcomment %}${1:content}{% endinputcomment %}\n\
\n\
\n\
snippet ic\n\
\t{% ic %}${1:content}{% endic %}\n\
\n\
\n\
snippet infotext\n\
\t{% ic %}{::infotext}${1:content}{:/infotext}{% endic %}\n\
\n\
\n\
snippet warningtext\n\
\t{% ic %}{::warningtext}${1:content}{:/warningtext}{% endic %}\n\
\n\
\n\
snippet cautiontext\n\
\t{% ic %}{::cautiontext}${1:content}{:/cautiontext}{% endic %}\n\
\n\
\n\
snippet linkto\n\
\t{% linkto ${1:url} %}${2:content}{% endlinkto %}\n\
\n\
\n\
snippet locale\n\
\t{% locale %}${1:content}{% endlocale %}\n\
\n\
\n\
snippet newline\n\
\t{% newline %}\n\
\n\
\n\
snippet newpage\n\
\t{% newpage %}\n\
\n\
\n\
snippet noinputcomment\n\
\t{% noinputcomment %}${1:content}{% endnoinputcomment %}\n\
\n\
\n\
snippet nic\n\
\t{% nic %}${1:content}{% endnic %}\n\
\n\
\n\
snippet raw\n\
\t{% raw %}${1:content}{% endraw %}\n\
\n\
\n\
snippet radiogroup\n\
\t{% radiogroup ${1:prefix}.${2:suffix} %}${3:content}{% endradiogroup %}\n\
\n\
\n\
snippet radioinput\n\
\t{% radioinput value:${1:value} %}\n\
\n\
\n\
snippet pop\n\
\t{% pop ${1:array} to:${2:var} %}\n\
\n\
\n\
snippet push\n\
\t{% push ${1:item} to:${2:array} %}\n\
\n\
\n\
snippet rollforward\n\
\t{% rollforward ${1:previous_value} ${2:custom.some.value} %}\n\
\n\
\n\
snippet result\n\
\t{% result "${1:name}" ${2:content} %}\n\
\n\
\n\
snippet stripnewlines\n\
\t{% stripnewlines %}${1:content}{% endstripnewlines %}\n\
\n\
\n\
snippet t\n\
\t{% t "${1:key}" %}\n\
\n\
\n\
snippet font\n\
\t{::font size=\'${1:l}\'}${2:content}{:/font}\n\
\n\
\n\
snippet include\n\
\t{% include "parts/${1:Part 1}" %}\n\
\n\
\n\
snippet render\n\
\t{% render "parts/${1:Part 1}", arg1:${2:arg1}, arg2:${3:arg2} %}\n\
\n\
\n\
snippet liquid\n\
\t{% liquid\n\
\t${1:code}\n\
\t%}\n\
\n\
\n\
snippet t=\n\
\t{% t= "${1:key}" ${2:default}:"${3:translation}" %}\n\
\n\
\n\
snippet unreconciled\n\
\t{% unreconciled ${1:amount} %}\n\
\n\
\n\
snippet unless\n\
\t{% unless ${1:condition} %}${2:content}{% endunless %}\n\
\n\
\n\
snippet indent\n\
\t{::indent level="${1:level}"}\n\
\t${2:content}\n\
\t{:/indent}\n\
\n\
\n\
snippet group\n\
\t{::group}\n\
\t${1:content}\n\
\t{:/group}\n\
\n\
\n\
snippet target\n\
\t{::target id="${1:target_id}"}${2:label}{:/target}\n\
\n\
\n\
snippet <table\n\
\t<table class="${1:}">\n\
\t\t<thead>\n\
\t\t\t<tr>\n\
\t\t\t\t<th class="${2:}">${3:content}</th>\n\
\t\t\t\t<th class="${4:}">${5:content}</th>\n\
\t\t\t</tr>\n\
\t\t</thead>\n\
\t\t<tbody>\n\
\t\t\t<tr>\n\
\t\t\t\t<td class="${6:}">${7:content}</td>\n\
\t\t\t\t<td class="${8:}">${9:content}</td>\n\
\t\t\t</tr>\n\
\t\t</tbody>\n\
\t</table>\n\
\n\
\n\
snippet <tr\n\
\t<tr>\n\
\t\t<td class="${1:}">${2:content}</td>\n\
\t\t<td class="${3:}">${4:content}</td>\n\
\t</tr>\n\
\n\
\n\
snippet <th\n\
\t<th class="${1:}">${2:content}</th>\n\
\n\
\n\
snippet <td\n\
\t<td class="${1:}">${2:content}</td>\n\
\n\
\n\
snippet <a\n\
\t<a href="${1:target}">${2:label}</a>\n\
\n\
\n\
'

    exports.scope = 'sf_liquid'
  }
)
